import { QuestionBase } from './question-base';

export class ReadOnlyTextareaLargeQuestion extends QuestionBase<string> {
  controlType = 'read-only-textarea-large';
  type: string;

  constructor(options: {} = {}) {
    super(options);
    this.type = options['type'] || '';
  }
}	
